import client from 'api/client';

export const addOffice = async payload => {
  const { data } = await client.post(`firms/offices/`, payload);
  return data;
};

export const findAndUpdateOffice = async payload => {
  const { data } = await client.patch(`firms/offices/${payload.id}/`, payload);
  return data;
};

export const deleteOffice = id => client.delete(`firms/offices/${id}/`);

export const validateOfficeData = payload => client.post('firms/offices/validate-office/', payload);

export const changePrimaryOffice = async payload => {
  const { data } = await client.patch(`firms/${payload.firm}/change-primary-office/`, {
    new_primary_office_id: payload.id,
  });
  return data;
};

export const addVirtualOffice = async payload => {
  const { data } = await client.post(`firms/virtual-offices/`, payload);
  return data;
};

export const findAndUpdateVirtualOffice = async payload => {
  const { data } = await client.patch(`firms/virtual-offices/${payload.id}/`, payload);
  return data;
};

export const deleteVirtualOffice = id => client.delete(`firms/virtual-offices/${id}/`);
